import { render, staticRenderFns } from "./Analyst.vue?vue&type=template&id=bfc83182&scoped=true&"
import script from "./Analyst.vue?vue&type=script&lang=js&"
export * from "./Analyst.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=bfc83182&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc83182",
  null
  
)

export default component.exports